import { Card } from "primereact/card"
import { Button } from "primereact/button"
import { useTranslation } from "react-i18next"
import { useState, useRef, Fragment } from "react"
import './listeLibelleThumbnail.css'
import { Chip } from "primereact/chip"

export const ListeLibelleThumbnail = (props) => {

    const { t } = useTranslation();
    const [expandedSections, setExpandedSections] = useState({});
    const contentRefs = useRef({});

    const toggleSection = (index) => {
        const isExpanded = !!expandedSections[index];
        setExpandedSections(prev => ({
            ...prev,
            [index]: !prev[index]
        }));

        // If we're collapsing the section, make sure to reset scroll to top
        if (isExpanded && contentRefs.current[index]) {
            contentRefs.current[index].scrollTop = 0;
        }
    };

    return (
        <>
            <Card className="p-shadow-5 listelibelle-thumbnail-card">
                <h1 className="vue-candidat-card-title">
                    {props.tabLibelles.length > 0 && props.titleplural ? props.titleplural : props.title}
                </h1>
                {props.tabLibelles.map((libelles, indexL) => {
                    const isExpanded = !!expandedSections[indexL];
                    const showToggle = libelles.length > 5;
                    const itemsToShow = libelles; // show all but control visible area with CSS

                    return (
                        <div key={indexL} className="competence-section">
                            {props.subTitles && <h4 className="listelibelle-thumbnail-subtitle">{props.subTitles[indexL]}</h4>}
                            <div
                                ref={el => contentRefs.current[indexL] = el}
                                className={`competence-section-content ${!isExpanded && showToggle ? 'competence-section-collapsed' : ''} ${isExpanded && showToggle ? 'competence-section-expanded' : ''}`}
                            >
                                {itemsToShow.map((item, itemIndex) => (
                                    <Fragment key={`${item}~${itemIndex}`}>
                                        {props.display === "chip" ? (
                                            <Chip className="p-mb-3" label={item}></Chip>
                                        ) : (
                                            <div className="listelibelle-thumbnail-lineheight">
                                                <span>{item}</span>
                                            </div>
                                        )}
                                    </Fragment>
                                ))}
                            </div>
                            {!isExpanded && showToggle && <div className="competence-section-fade-overlay"></div>}
                            {showToggle && (
                                <div className="competence-section-toggle-container">
                                    <Button 
                                        label={isExpanded ? t('general.see_less') : t('general.see_more')}
                                        className="competence-section-toggle-btn"
                                        onClick={() => toggleSection(indexL)}
                                        text
                                    />
                                </div>
                            )}
                            {indexL !== props.tabLibelles.length - 1 && <br />}
                        </div>
                    )
                })}
            </Card>
        </>
    )
}